module.exports = __webpack_public_path__ + "media/images/wealthbar/dashboard/waving-hand-d8ce2d24f4c4604c26cfc7e4ff3610b5.png";